import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  DepartmentListRequest,
  DepartmentListResponse,
  Department,
  DepartmentShortListRequest,
  DepartmentShortListResponse,
  DepartmentCreateRequest,
  DepartmentUpdateRequest,
} from "./types";

/**
 * List
 */
export const departmentListService = (params: DepartmentListRequest) =>
  RestAPIClient.call<DepartmentListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * List short
 */
export const departmentListShortService = (
  params: DepartmentShortListRequest
) =>
  RestAPIClient.call<DepartmentShortListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * Detail
 */
export const departmentDetailService = (id: number) =>
  RestAPIClient.call<Department>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

/**
 * Create
 */
export const departmentCreateService = (data: DepartmentCreateRequest) =>
  RestAPIClient.call<Department>({
    method: HTTPRequestMethods.POST,
    url: `${Paths.Create}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Update
 */
export const departmentUpdateService = (data: DepartmentUpdateRequest) =>
  RestAPIClient.call<Department>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${data.id}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Delete
 */
export const departmentDeleteService = (data: { id: number }) =>
  RestAPIClient.call<Department>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Delete}/${data.id}`,
    config: {
      requireAuthentication: true,
    },
  });

/**
 * Update status
 */
export const departmentUpdateStatusService = ({
  id,
  isActive,
}: {
  id: number;
  isActive: boolean;
}) =>
  RestAPIClient.call<Department>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${id}/${isActive ? "active" : "inactive"}`,
    config: {
      requireAuthentication: true,
    },
  });
